/* Close the mobile drawer when a category opens an anchor on the same page. */
document.addEventListener('click', (event) => {
  const link = event.target.closest('header-drawer a[href]');
  if (!link) return;
  const destination = new URL(link.href, location.href);
  if (destination.pathname !== location.pathname || !destination.hash) return;
  const drawer = link.closest('header-drawer');
  const summary = drawer.querySelector('#Details-menu-drawer-container > summary');
  if (summary && typeof drawer.closeMenuDrawer === 'function') drawer.closeMenuDrawer(event, summary);
});
